var render, staticRenderFns
import script from "./RiskInfoBase.vue?vue&type=script&lang=js&"
export * from "./RiskInfoBase.vue?vue&type=script&lang=js&"
import style0 from "./RiskInfoBase.vue?vue&type=style&index=0&id=4c6726a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6726a4",
  null
  
)

export default component.exports